import {createApp} from 'vue';
import {connectVue} from '../modules/configureBugsnag';
import configureGlobalComponents from '../modules/configureGlobalComponents';
import useConciergeModal from '../composables/useConciergeModal';

const app = createApp({
    props: {
        user: {type: Object},
    },
    setup(props) {
        return useConciergeModal(props.user);
    },
}, window.propsData);

connectVue(app);
configureGlobalComponents(app);
app.mount('#auto-expert');
